/* eslint-disable-next-line no-undef */
const BASE_URL = `${siteUrl}api/gms/v1/member/`;

export default {
    /**
     * Get a list of available countries.
     *
     * @return {Array} [{Object}, ...]
     */
    getDmpBalance() {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}dmp`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },

    /**
     * Search members by using a firstname or lastname parameter.
     *
     * @param  {Object} params
     * @return {Array}
     */
    searchMembers(params) {
        return new Promise((resolve, reject) => {
            axios.get(`${BASE_URL}search`, {
                params,
            })
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                // handle error
                console.log(error);
                reject(error);
            });
        });
    },
};
